import * as React from "react";
import {HomeInsights} from "./HomeInsights";
import {HomeSharedDocuments} from "./HomeSharedDocuments";
import {HomeResearch} from "./HomeResearch";
import {hasConsultantLevelAccess, hasResearchPageAccess} from "../../utils/sessionUtil";
import {CprPortfolioOverview} from "./CprPortfolioOverview";
import {IPlanInfo} from "../../model/ClientsAndPlans.model";
import {HomeAssetTrends} from "./HomeAssetTrends";
import {useDispatch} from "react-redux";
import {AdminActionTypes} from "../research/edit-portfolio/editPortfolioActions";
import {AnyThunkDispatch} from "../../../commonTypes";
import {HomeHeader} from "./HomeHeader.component";

export interface IHomeProps {
    insightsEnabled: boolean;
    sharedDocumentsEnabled: boolean;
    hasResearchAccess: boolean;
    hasPortfolioAccess: boolean;
    clientPortfolioEnabled: boolean;
    currentPlan: IPlanInfo;
    clientPerformanceReportingAccess: boolean;
    cprPortfolioOverviewEnabled: boolean;
    editingPlanPortfolio: boolean;
}

export const Home: React.FunctionComponent<IHomeProps> = (props) => {
    if (props.editingPlanPortfolio) {
        const dispatch: AnyThunkDispatch = useDispatch();
        dispatch({type: AdminActionTypes.END_EDIT_PORTFOLIO});
    }

    const renderCprPortfolioOverview = () => {
        return props.currentPlan.powerbiId
            ? <CprPortfolioOverview
                clientPerformanceReportingAccess={props.clientPerformanceReportingAccess}
                cprPortfolioOverviewEnabled={props.cprPortfolioOverviewEnabled}
            />
            : null;
    };

    const renderAssetTrends = () => {
        return (props.hasPortfolioAccess && (hasConsultantLevelAccess() || props.clientPortfolioEnabled))
            ? <HomeAssetTrends />
            : null;
    };

    const showResearch = hasResearchPageAccess(
        props.hasResearchAccess,
        props.hasPortfolioAccess,
        props.clientPortfolioEnabled);
    const showResources = props.sharedDocumentsEnabled || showResearch;

    // Determine layout class based on what's shown
    const layoutClass = props.insightsEnabled && showResources
        ? "home__content-layout"
        : props.insightsEnabled
            ? "home__content-layout"
            : "home__content-layout home__content-layout--resources-only";

    return <div className="home-common-styles home__container" data-testid="home__container">
        <HomeHeader/>
        {renderAssetTrends()}
        {renderCprPortfolioOverview()}

        <section className="home__content-section">
            <div className="home__content-inner">
                <div className={layoutClass}>
                    {props.insightsEnabled && <HomeInsights />}
                    {showResources && (
                        <div className="home__resources-panel">
                            {props.sharedDocumentsEnabled && <HomeSharedDocuments />}
                            {showResearch && <HomeResearch />}
                        </div>
                    )}
                </div>
            </div>
        </section>
    </div>;
};
